import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useOrganization } from '@/contexts/OrganizationContext';
import type { CampaignPerformanceDataPoint } from '@/lib/utils/aggregateCampaignPerformance';
import { campaignKeys } from '../services/campaign.keys';

export function useCampaignPerformanceTimeSeries(campaignId: string) {
  const { currentOrganization } = useOrganization();

  return useQuery<CampaignPerformanceDataPoint[]>({
    queryKey: campaignKeys.timeSeries(campaignId),
    queryFn: async (): Promise<CampaignPerformanceDataPoint[]> => {
      const { data, error } = await supabase.rpc('get_campaign_performance_timeseries', {
        p_campaign_id: campaignId,
      });

      if (error) throw error;

      return (data ?? []).map(
        (row: {
          month_label: string;
          reach: number;
          engagement: number;
          views: number;
          impressions: number;
        }) => ({
          name: row.month_label,
          reach: Number(row.reach),
          engagement: Number(row.engagement),
          views: Number(row.views),
          impressions: Number(row.impressions),
        })
      );
    },
    enabled: !!campaignId && !!currentOrganization?.id,
    staleTime: 3 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
